/** 全局启动骨架：认证初始化（getSession）期间顶替空白首屏，主题已由 main.tsx 提前应用。 */
import css from './BootSkeleton.module.css'

/**
 * Render the full-viewport boot placeholder shown while the auth session is
 * being resolved. Matches the AppShell brand copy so the hand-off to the shell
 * does not shift layout or wording.
 * @returns an aria-live status surface with brand, spinner and status text.
 */
export function BootSkeleton() {
  return (
    <div
      className={css.boot}
      role="status"
      aria-live="polite"
      aria-label="正在确认登录状态…"
    >
      <span className={css.brand}>统一控制台</span>
      <span className={css.spinner} aria-hidden="true" />
      <span className={css.status}>正在确认登录状态…</span>
    </div>
  )
}
